<template>
  <!-- <div id="main-container" class="" style="padding-top:40px; background-color:red"> -->
  <!-- container -->
  <div class="row q-pa-md" style="margin: 0 auto; max-width: 1280px">
    <!-- Left Side -->
    <div class="col-xs-12 col-sm-12 col-md-6" v-if="product">
      <div>
        <q-carousel width="100%" animated v-model="slide" swipeable arrows fullscreen :fullscreen.sync="fullscreen" :autoplay="autoplay" ref="carousel" infinite >
          <q-carousel-slide :name="index" v-for="(image, index) in product.images" v-bind:key="index" class="column no-wrap">
            <img :src="image.url" class="rounded-borders col-12" style="object-fit: scale-down"/>
          </q-carousel-slide>
        </q-carousel>
      </div>
      <div id="sub_images" class="row col-12">
        <div v-for="(image, index) in product.images" :style="slide == index ? selected : null" v-bind:key="index" style=" width: 90px; height: 90px; border: solid 1px silver; margin: 5px; " @click="slide = index" >
          <q-img
            :src="image.url"
            width="100%"
            height="100%"
            spinner-color="primary"
            spinner-size="10px"
          />
        </div>
      </div>
    </div>
    <!-- Right Side -->
    <div v-if="productDetails && product" class="col-xs-12 col-sm-12 col-md-6 q-pa-sm">
      <q-badge
        v-if="productDetails.basic_details.options.show_status_tag"
        class="customBadge"
        color="blood"
        label="New"
      ></q-badge>
      <div style="font-size: 44px">{{ product.name }}</div>
      <div v-if="productDetails.basic_details.show_subtitle" id="short_description" >
      <span style="font-weight:bold">{{productDetails.basic_details.subtitle}}</span>
      </div>
      <div id="second_line" style="margin-top: 10px">
        <div id="price" v-if="storeType == 'retail'" >
          <div style="font-size: 24px; color: #6f6f6f; display: inline">${{Number(product.skus[0].retailPrice).toFixed(2)}}</div>
            <humm-info :price="Number(product.skus[0].retailPrice).toFixed(2)"></humm-info>
        </div>
        <div id="price" style="font-size: 24px; color: #6f6f6f; display: inline" v-else>
          ${{Number(product.skus[0].price).toFixed(2)}}
        </div>
        <div
          v-if="productDetails.basic_details.options.show_rating_stars"
          id="reviews"
          class="text-right"
          style="display: inline; float: right"
        >
          <q-icon size="sm" color="red-10" name="star" />
          <q-icon size="sm" color="red-10" name="star" />
          <q-icon size="sm" color="red-10" name="star_half" />
          <q-icon size="sm" color="red-10" name="star_outline" />
          <q-icon size="sm" color="red-10" name="star_outline" />
          <!-- <div id="review_link" style="display:inline"><a href="http://localhost">Read reviews</a></div> -->
        </div>
      </div>
      <!-- <q-separator class="q-my-lg"></q-separator> -->

      <component :is="longDescription"/>

      <q-separator class="q-my-lg"></q-separator>
      <div id="colour_selection" class="row" style="height: 40px; display:none">
        <div style=" display: inline; font-size: 16px; margin-right: 20px; line-height: 40px;">
          Colour: <span class="text-bold">{{ product.skus[colourSelection].options.colour.group }}</span>
        </div>
        <!-- <div style="display:inline; width:200px">
              <q-select outlined v-model="colourSelection" :options="colourOptions" dense options-dense>
                <template v-slot:prepend>
                  <q-icon name="event" />
                </template>
              </q-select>
            </div> -->
      </div>
      <div
        class="row"
        id="colour_display"
        style="margin: 20px"
        v-if="setQtyComp"
      >
        <!-- <div style="position:absolute; background-color:red; width: 20px; height:20px;border:1px black solid; border-radius:50px">X</div>
            <div style="background-color:yellow; width: 40px; height:40px;border:1px silver solid; border-radius:50px"> -->
        <!-- </div> -->
        <div id="colour_component" style="display:none; width: 60px" v-for="(sku, index) in product.skus" @click="colourSelection = index" >
          <div id="caja" style="width: 50px; height: 50px; margin: 0 auto">
            <div
              v-if="colourSelection == index"
              id="selector"
              style="
                border-radius: 50px;
                position: absolute;
                width: 50px;
                height: 50px;
                border: 2px solid black;
              "
            ></div>
            <div
              v-if="colourSelection == index"
              id="tick"
              style="
                border: 2px solid white;
                border-radius: 50px;
                position: absolute;
                z-index: 1;
                width: 15px;
                height: 15px;
                background-color: black;
                margin: 34px;
              "
            >
              <div style="position: absolute; margin-top: -5px">
                <q-icon
                  color="white"
                  size="10px"
                  name="check"
                  style="font-weight: bold"
                />
              </div>
            </div>
            <div
              id="colour_circle"
              :style="`background-color:${sku.options.colour.hex}`"
              style="
                border: 2px #f6f6f6 solid;
                border-radius: 50px;
                position: absolute;
                width: 40px;
                height: 40px;
                margin: 5px;
              "
            ></div>
            <!-- <div id="colour_qty" class="text-center " style="color: black; text-shadow: -0.7px -0.7px 0 #fff, 0.7px -0.7px 0 #fff, -0.7px 0.7px 0 #fff, 0.7px 0.7px 0 #fff; font-size:11px; background-color:;position:absolute; width:50px;z-index:1; margin:18px 0">{{index}}</div> -->
            <div
              v-if="productDetails.basic_details.options.show_qty_colour"
              id="colour_qty"
              class="text-center text-bold"
              style="
                font-size: 11px;
                position: absolute;
                width: 50px;
                z-index: 1;
                margin: 18px 0;
              "
            >
              {{ colourQty[index] }}
            </div>
          </div>
          <!-- <div id=colour_name class="text-center" style="font-size:10px;">{{sku.options.colour.name}}</div> -->
        </div>
      </div>

      <div id="buttons" class="row justify-center" style="margin: 15px 0">
        <q-input
          :min="0"
          :max="10"
          v-model="colourQty[colourSelection]"
          @input="onInput($event, colourSelection)"
          @keydown="keyHandler($event, colourSelection)"
          debounce="1000"
          maxlength="5"
          dense
          outlined
          input-style="font-weight:bold; text-align:center; width:60px;"
          style="margin: 0 10px"
        >
          <template v-slot:prepend>
            <q-btn
              color="black"
              @click="removeOne(colourSelection)"
              dense
              flat
              icon="remove"
              style="margin: -8px"
            />
          </template>
          <template v-slot:append>
            <q-btn
              color="black"
              @click="addOne(colourSelection)"
              dense
              flat
              icon="add"
              style="margin: -8px"
            />
          </template>
        </q-input>
        <q-btn color="primary" label="Add to cart" />
        <q-btn
          v-if="productDetails.basic_details.options.show_whishing_btn"
          style="margin: 0 10px"
          icon="favorite_border"
        />
      </div>
      <div v-if="productDetails.basic_details.options.show_stock_message">
        <component :is="stockMessageContent"/>
      </div>

    </div>
    <div class="col-12" v-if="productDetails">
      <!-- Content -->
      <div v-if="productDetails.feature_panel.show" class="col-12" style="margin: 50px 0px" >
          <component :is="featureContent"/>
      </div>
    </div>

    <q-dialog v-model="showHummModal">
      <div class="humm-price-info-modal" style="min-width:780px">
        <div class="header">
          <div class="title"><img src="../../assets/logo-orange.svg" alt="humm logo"></div>
          <div class="sub-title">
            <span>No interest ever. Pay in slices over <span id='months'>{{hummData.numberOfMonths}}</span> months.</span>
          </div>
        </div>
        <div class="pricing-wrapper">
          <div class="pricing">
            <div class="pricing-left">
              Pay <strong>$<span id='deposit'>{{hummData.depositAmount}}</span></strong> today, then <br> <strong><span id='repayments'>{{hummData.numberOfRepayments}}</span></strong> fortnightly payments of <strong>$<span id='payments'>{{hummData.repaymentAmount}}</span></strong><sup>1</sup>
            </div>
            <div class="pricing-right">
              Total amount payable is <strong>$<span id='total-amount'>{{hummData.totalPayableAmount}}</span></strong>,<br> which includes the
              <strong>$<span id='purchase-amount'>{{hummData.totalPayableAmount - (hummData.numberOfMonths * hummData.monthlyAccountKeepingFee)}}</span></strong> purchase price, <br>
              <span id='fee-repayments'>{{hummData.numberOfMonths}}</span> x <strong>$<span id='mak-fee'>{{hummData.monthlyAccountKeepingFee}}</span></strong> monthly fees, and
              a<br>
              <strong>$<span id='establishment-fee'>{{hummData.establishmentFeeAmount}}</span></strong> establishment fee
            </div>
          </div>
        </div>
        <div class="main-wrapper">
          <div class="main">
            <div class="card">
              <img src="../../assets/cart-orange.svg" alt="cart">
              <div class="title">Shop now</div>
              <div class="content">Choose <strong>humm</strong> as your payment option in the online checkout.</div>
            </div>
            <div class="card-dividor">
              <img src="../../assets/arrow-orange.svg" alt="">
            </div>
            <div class="card">
              <img src="../../assets/login-orange.svg" alt="login">
              <div class="title">Login or Sign Up</div>
              <div class="content">You will be directed to the <strong>humm</strong> portal to login or sign up.</div>
            </div>
            <div class="card-dividor">
              <img src="../../assets/arrow-orange.svg" alt="dividor">
            </div>
            <div class="card">
              <img src="../../assets/watch-orange.svg" alt="watch">
              <div class="title">Complete Purchase</div>
              <div class="content">Your items will be delivered to your door.</div>
            </div>
          </div>
        </div>
        <div class="footer-wrapper">
          <div class="footer">
            <div class="footer-left">
              <span class="fine-print">Plan to approved applicants only; fees, terms, conditions, minimum amounts and exclusions apply. Payment plan provided by humm BNPL Pty Ltd ABN 28 129 228 986.</span>
            </div>
            <div class="footer-right">
              <span class="fine-print"><span class="orange">What do I need to apply for humm?</span>
              <ul>
                <li>Provide a one-off electronic bank statement.</li>
                <li>Be 18 years or older</li>
                <li>Be a permanent resident or citizen</li>
                <li>Hold an Australian driver's license, Australian passport or Medicare card</li>
                <li>Have a permanent job (at least 25 hours a week) or be on aged/veteran&rsquo;s pension</li>
                <li>Hold an Australian Visa or Mastercard debit or credit card</li>
              </ul>
              </span>
            </div>
          </div>
        </div>
      </div>
    </q-dialog>

  </div>
  <!-- </div> -->


</template>


<script>
import moment from "moment";
import gql from "graphql-tag";

export default {
  name: "ProductDetails",
  components: {
    HummInfo: () => import('../../components/HummInfo.vue')
  },
  apollo: {
    cart() {
      return {
        query: gql`
          query cart($id: ID!) {
            cart(id: $id) {
              id
              items {
                id
                skuId
                qty
                sku {
                  id
                  options
                  product {
                    id
                    name
                    attributes
                  }
                }
              }
            }
          }
        `,
        variables() {
          return {
            id: this.$store.state.auth.retailCartId,
          };
        },
        context: {
          headers: {
            uuid: this.UUID,
          },
        },
        fetchPolicy: "network-only",
      };
    },
    product() {
      return {
        query: gql`
          query product($id: ID!) {
            product(id: $id) {
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInContainer
                showInRetail
                hideInStock
                stock
                colour
                deleted
              }
            }
          }
        `,
        variables() {
          return {
            id: this.$route.params.id,
          };
        },
        context: {
          headers: {
            uuid: this.UUID,
          },
        },
        fetchPolicy: "network-only",
      };
    },
    productDetails() {
      return {
        query: gql`
          query productDetails($id: ID!) {
            productDetails(id: $id) {
              id
              productId
              basic_details {
                subtitle
                show_subtitle
                stock_message
                options
              }
              feature_panel {
                show
                content
              }
              technical_details_panel {
                show
                content
              }
              review_panel {
                show
                show_rating_breakdown
                show_product_recomendation_subpanel
                show_write_btn
                show_helpful_line
              }
            }
          }
        `,
        variables() {
          return {
            id: this.$route.params.id,
          };
        },
        context: {
          headers: {
            uuid: this.UUID,
          },
        },
        fetchPolicy: "network-only",
      };
    },
  },
  data() {
    return {
      showHummModal: false,
      hummLoaded: false,
      hummData:{},
      name: "abc",
      slideValue: "2",
      objMarkerLabel: { 0: "Poor", 10: "Great" },
      date: new moment().format("LLL"),
      reviewSort: "Most Recent",
      options: [
        "Most Recent",
        "Most Relevant",
        "Most Helpful",
        "High to Low (Rating)",
        "Low to High (Rating)",
      ],
      colourSelection: 0,
      colourOptions: ["red", "blue", "yellow"],
      slide: 0,
      autoplay: false,
      fullscreen: false,
      selected: "border:4px solid black",
      colourQty: [],
      execCounter: 0,
      images:'',
      viewerPerc: 0,
    };
  },

  mounted (){
    this.scrollWatcher();
  },
  computed: {
    stockMessageContent(){
      let product = Object.assign({},this.product)
      return {
        data(){
          return{
            product
          }
        },
        template: this.productDetails.basic_details.stock_message
      }
    },
      featureContent: function() {
      return {
        template: this.productDetails.feature_panel.content,
      }
    },
    longDescription: function() {
      return {
        template: this.productDetails.technical_details_panel.content,
      }
    },
    storeType(){
      return this.$store.state.cart.currentStoreType
    },
    id() {
      return this.$route.params.id;
    },
    cartId() {
      return this.$store.state.cart.activeRetailCart.id;
    },
    UUID(){
      return this.$store.state.auth.currentUUID;
    },
    async setQtyComp() {
      if(this.cart){
        for (let i = 0; i < this.product.skus.length; i++) {
          let flag = false;
          for (let item of this.cart.items) {
            if (item.skuId == this.product.skus[i].id) {
              this.colourQty[i] = item.qty;
              flag = true;
              continue;
            }
          }

          if (!flag) {
            this.colourQty[i] = 0;
          }
        }
      }
    },
  },
  methods: {
    scrollWatcher(){
      window.onscroll = () => {
        let viewed = (((Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) / document.documentElement.offsetHeight) * 100).toFixed(0)
        if(viewed % 10 == 0 && viewed > this.viewerPerc ){
          this.viewerPerc = Math.max(this.viewerPerc,viewed)
            analytics.track("Product Details % Viewed",{
              storeType: this.$store.state.cart.currentStoreType,
              product: this.product.name,
              where: "Product Details Page"
            });
        }
      }
    },
    async updateBasket(skuId, value) {
      value = Number(value);
      try {
        if ( value > 0 && !this.cart.items.find((item) => item.skuId === skuId) ) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation addItemToCart($cartId: ID!, $input: CartItemInput!) {
                addItemToCart(id: $cartId, input: $input) {
                  id
                  items {
                    id
                    skuId
                    sku {
                      id
                      price
                      containerPrice
                      retailPrice
                      options
                      stock
                      product {
                        id
                      }
                    }
                    qty
                  }
                }
              }
            `,
            variables: {
              cartId: this.cartId,
              input: {
                skuId: skuId,
                qty: value,
              },
            },
            context: {
              headers: {
                uuid: this.UUID,
              },
            },
            skip() {
              return !value;
            },
          });

          const skuToSendToAnalytics = await this.cart.items.find( (item) => item.skuId === skuId ).sku;
          analytics.track("Add Item To Cart", {
            cartId: this.cartId,
            skuId: skuId,
            sku: skuToSendToAnalytics,
            qty: value,
            where: "Product Details Page",
            storeType: this.$store.state.cart.currentStoreType
          });
        } else if (
          value === 0 &&
          this.cart.items.find((item) => item.skuId === skuId)
        ) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation deleteItemFromCart($cartId: ID!, $skuId: ID!) {
                deleteItemFromCart(id: $cartId, skuId: $skuId) {
                  id
                  items {
                    id
                    skuId
                    qty
                  }
                }
              }
            `,
            variables: {
              cartId: this.cartId,
              skuId: skuId,
            },
            context: {
              headers: {
                uuid: this.UUID,
              },
            },
          });
          analytics.track("Delete Item From Cart", {
            cartId: this.cartId,
            skuId: skuId,
            where: "Product Details Page",
            storeType: this.$store.state.cart.currentStoreType
          });


        } else if (this.cart.items.find((item) => item.skuId === skuId)) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation editItemInCart(
                $cartId: ID!
                $skuId: ID!
                $input: CartItemInput!
              ) {
                editItemInCart(id: $cartId, skuId: $skuId, input: $input) {
                  id
                  items {
                    id
                    skuId
                    qty
                  }
                }
              }
            `,
            variables: {
              cartId: this.cartId,
              skuId: skuId,
              input: {
                qty: value,
              },
            },
            context: {
              headers: {
                uuid: this.UUID,
              },
            },
          });

          analytics.track("Edit Item In Cart", {
            cartId: this.cart.id,
            skuId: skuId,
            updates: {
              qty: value,
            },
            where: "Product Details Page",
            storeType: this.$store.state.cart.currentStoreType
          });
        }
      } catch (err) {
        // this.$q.notify({
        //   message: 'Error updating!',
        //   color: 'negative',
        //   icon: 'report_problem'
        // })
      }
      this.$store.commit(
        `cart/setCartRetailQty`,
        this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0)
      );
    },
    getData() {
      return JSON.stringify(this.$store.state.cart.activeContainerCart);
    },
    async addOne(index) {
      let newVal = this.colourQty[index] + 1;
      this.$set(this.colourQty, index, newVal);
      let skuid = this.product.skus[index].id;
      // await this.editItemInCart_mutation(this.cartId, skuid, newVal)
      await this.updateBasket(skuid, newVal);
    },
    async removeOne(index) {
      let val = this.colourQty[index];
      let newVal;
      if (val > 0) newVal = val - 1;
      else newVal = 0;

      let skuid = this.product.skus[index].id;
      // await this.editItemInCart_mutation(this.cartId, skuid, newVal)
      await this.updateBasket(skuid, newVal);
    },
    async manual_qty_update(index, qty) {
      this.$set(this.colourQty, index, qty);
    },
    async onInput(val, index) {
      // console.log('val,index',val,index);
      let newVal = val;
      this.colourQty[index] = val;
      if (val && val < 0) {
        this.colourQty[index] = 0;
        newVal = 0;
      }
      let skuid = this.product.skus[index].id;
      await this.updateBasket(skuid, newVal);
    },
    keyHandler(evt, index) {
      if (this.colourQty[index] < 1 && evt.key === "ArrowDown") {
        evt.preventDefault();
      }
      if (evt.key === "-") {
        evt.preventDefault();
      }
    },
    //Input: Cart ID, SKU ID and Quantity
    async addItemToCart_mutation(cartId, skuId, qty) {
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`
            mutation addItemToCart($cartId: ID!, $input: CartItemInput!) {
              addItemToCart(id: $cartId, input: $input) {
                id
                items {
                  id
                  skuId
                  sku {
                    id
                    price
                    containerPrice
                    retailPrice
                    options
                    stock
                    product {
                      id
                    }
                  }
                  qty
                }
              }
            }
          `,
          variables: {
            cartId: cartId,
            input: {
              skuId: skuId,
              qty: Number(qty),
            },
          },
          context: {
            headers: {
              uuid: this.UUID,
            },

          },
          skip() {
            return !qty;
          },
        });
        console.log("addItemToCart", result);
      } catch (err) {
        console.log("ERROR addItemToCart", err);
      }
      this.$store.commit(
        `cart/setCartRetailQty`,
        this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0)
      );
    },
    async editItemInCart_mutation(cartId, skuId, qty) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation editItemInCart(
              $cartId: ID!
              $skuId: ID!
              $input: CartItemInput!
            ) {
              editItemInCart(id: $cartId, skuId: $skuId, input: $input) {
                id
                items {
                  id
                  skuId
                  qty
                }
              }
            }
          `,
          variables: {
            cartId: cartId,
            skuId: skuId,
            input: {
              qty: qty,
            },
          },
            context: {
              headers: {
                uuid: this.UUID,
              },
            },
        });
      } catch (err) {
        console.log("ERROR editItemInCart_mutation", err);
      }
      this.$store.commit(
        `cart/setCartRetailQty`,
        this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0)
      );
    },
  },
};
</script>




<style scoped lang="stylus">
@import '~quasar-variables';
@import '~quasar-styl'

.customBadge {
  padding: 3px 6px;
  font-size: 14px;
  border: 2px solid #C5171C;
  color: #C5171C;
  background-color: white;
}
</style>


